import { useEffect, useState } from 'react';
import { SelectOpt } from '../../common/CommonTypes';
import SelectInput from '../selectInput/SelectInput';
import { Provinces } from 'Constants/Common';
import { useTranslation } from 'react-i18next';

export type ProvinceProps = {
    province: string;
    onChangeProvince: (selectedValue: string) => void;
};

const Province = ({
    province,
    onChangeProvince
}: ProvinceProps): JSX.Element => {
    const [provinces, setProvinces] = useState<SelectOpt[]>([]);

    const { t } = useTranslation();

    useEffect(() => {
        if (!provinces || provinces.length < 1) {
            setProvinces(
                Provinces.optionsdata.map((s) => {
                    return {
                        id: s.key,
                        text: s.value,
                        value: s.key,
                        disabled: false
                    } as SelectOpt;
                })
            );
        }
    }, [provinces]);

    return (
        <SelectInput
            name='province'
            className='province-select-padding '
            loadingText={t('loading')}
            label={t('select_province')}
            value={province}
            options={provinces}
            onChange={onChangeProvince}
            forceDefault
            defaultIfOneOption
            addDefaultOption
            defaultText={t('select_default')}
        />
    );
};

export default Province;
